const doc = [({"en":({"js":({"admin":({"invoices":({"show":({"show_invoice":"Show invoice %{id}", "show_logs_for_invoice":"Logs for invoice %{id}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;